declare const OP: any;

const translateText = (key: string): string => {
  const translatedValue = OP.CategoryProduct.initialI18nStore.default.translations[key];
  return translatedValue || key;
};

export default translateText;
